/* eslint-disable react/jsx-no-target-blank */
// react imports
import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../AppContextProvider";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import SideNavComponent from "./header/SideNavComponent";
import { MDBContainer, MDBSideNav, MDBSideNavMenu } from "mdb-react-ui-kit";
import { WalletProviderContext } from "../walletprovider/WalletProvider";
import DwinityLoader from "../components/DwinityLoader";
import MessageModal from "../modals/MessageModal";
import InfoModalLeft from "../modals/InfoModalLeft";
import InfoModalRight from "../modals/InfoModalRight";
import InfoModalCentral from "../modals/InfoModalCentral";
import FileUploadsModal from "../modals/FileUploadsModal";
import ImportOrUploadModal from "../modals/ImportOrUploadModal";
import DataimportModal from "../modals/DataimportModal";
import MetaDownloadHelpModal from "../modals/MetaDownloadHelpModal";
import NewFolderModal from "../modals/NewFolderModal";
import MetafileModal from "../modals/MetafileModal";
import CategoriesModal from "../modals/CategoriesModal";
import TimeLineModal from "../modals/TimeLineModal";
import CategoriesModalTest from "../modals/CategoriesModalTest";
import InfoModalDownloadError from "../modals/InfoModalDownloadError";
import InfoGraphModal from "../modals/InfoGraphModal";
import FilePreviewModal from "../modals/FilePreviewModal";
import Modal from "../components/imageupload/Modal";
import ResumeUploadModal from "../modals/ResumeUploadModal";
import OrchestratorHealthBanner from "../components/OrchestratorHealthBanner";

import { FILES_PAGE, LOGIN_PAGE_URL } from "../data/pages";

function Layout(props) {
  const { t } = useTranslation();
  const context = useContext(AppContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isConnected, selectedAccount, selectedWallet, disconnectWallet } = useContext(WalletProviderContext);
  const [navbarShrunk, setNavbarShrunk] = useState(false);
  const [showHelpPopup, setShowHelpPopup] = useState(false);

  const hasSideNav = false;

  const docServer = process.env.DOCS_SERVER ?? "https://docs.dwinity.com";

  const scrollEventListener = () => {
    setNavbarShrunk(window.scrollY < 50 ? false : true);
  };

  useEffect(() => {
    document.addEventListener("scroll", scrollEventListener);
    return () => {
      document.removeEventListener("scroll", scrollEventListener);
    };
  }, []);

  // utils/metamaskInApp.js
  function isMetaMaskInAppBrowser() {
    const ua = navigator.userAgent || "";
    // A MetaMask Mobil UA általában tartalmazza ezt:
    const uaHit = /MetaMaskMobile/i.test(ua);
    // Ha dApp-ként futunk, a provider is jelen lehet:
    const hasProvider = typeof window !== "undefined" && window.ethereum && window.ethereum.isMetaMask;
    // mobil jelek:
    const isMobile = /Android|iPhone|iPad|iPod/i.test(ua);
    return (uaHit || hasProvider) && isMobile;
  }

  function smartOpenInNewTab(e, url) {
    if (!url) return;
    if (isMetaMaskInAppBrowser()) {
      // MetaMask in-app: megpróbáljuk programozottan új tabon
      e?.preventDefault?.();
      window.location.assign(url);
    } else {
      // Normál böngészőben hagyjuk a defaultot (a target="_blank" megteszi)
      // Ha itt is kézben akarod tartani:
      // e?.preventDefault?.();
      // window.open(url, "_blank", "noopener");
    }
  }

  return (
    <>
      {context.getState()?.isLoading && <DwinityLoader />}
      {pathname !== "/login" && <Header className={pathname === "/invitations" ? "invitations-header" : ""} />}
      <OrchestratorHealthBanner />
      <div className={`px-0 examples-home-page${pathname === "/invitations" ? " invitations-shell" : ""}`}>
        <main style={{ width: "100%" }}>
          <MDBContainer fluid className="homepage-container">
            {/*hasSideNav && (
              <MDBSideNav
                className={navbarShrunk ? "sidebar padding-top d-none d-lg-flex" : "sidebar d-none d-lg-flex"}
                style={{ width: context?.getState()?.modeOpen ? 0 : "400px" }}
                mode="side"
                isOpen={!context.getState()?.modeOpen}
              >
                <MDBSideNavMenu className="side-panel-menu">
                  <SideNavComponent setBasicOpen={() => {}} />
                </MDBSideNavMenu>
              </MDBSideNav>
            )*/}
            <Outlet />
          </MDBContainer>
        </main>
        {selectedAccount && pathname !== "/login" && pathname !== "/" && (
          <>
            <div className="d-none d-lg-flex desktop-footer">
              <div className="help-button">
                <button className="button outline medium" onClick={() => setShowHelpPopup(!showHelpPopup)}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" stroke="#ffffff" strokeWidth="2"/>
                    <path d="M9.5 9.5C9.5 8.11929 10.6193 7 12 7C13.3807 7 14.5 8.11929 14.5 9.5C14.5 10.4561 13.9407 11.2755 13.1291 11.6614C12.5077 11.9572 12 12.4477 12 13.1364V13.5" stroke="#ffffff" strokeWidth="2" strokeLinecap="round"/>
                    <circle cx="12" cy="17" r="1" fill="#ffffff"/>
                  </svg>
                  <span className="text">{t('header.menu.help')}</span>
                </button>
                {showHelpPopup && (
                  <>
                    <div style={{ position: 'fixed', inset: 0, zIndex: 9998 }} onClick={() => setShowHelpPopup(false)} />
                    <div style={{
                      position: 'absolute', bottom: 'calc(100% + 12px)', right: 0, zIndex: 9999,
                      background: '#14142a', border: '1px solid rgba(233, 30, 140, 0.3)', borderRadius: 16,
                      padding: 24, minWidth: 320, boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                        <span style={{ fontSize: 18, fontWeight: 600, color: '#fff' }}>{t('header.menu.help')}</span>
                        <button onClick={() => setShowHelpPopup(false)} style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', padding: 4, fontSize: 18, lineHeight: 1 }}>✕</button>
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <button
                          onClick={() => { setShowHelpPopup(false); context.openModal("infomodalleft", ""); }}
                          style={{
                            display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', background: 'rgba(233, 30, 140, 0.08)',
                            border: '1px solid rgba(233, 30, 140, 0.2)', borderRadius: 12, color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 500, textAlign: 'left', fontFamily: 'inherit',
                          }}
                        >
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#e91e8c" strokeWidth="2"/><path d="M12 8V12M12 16H12.01" stroke="#e91e8c" strokeWidth="2" strokeLinecap="round"/></svg>
                          {t("login.instructions.web3Ecosystem")}
                        </button>
                        <button
                          onClick={() => { setShowHelpPopup(false); context.openModal("infomodalright", ""); }}
                          style={{
                            display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', background: 'rgba(233, 30, 140, 0.08)',
                            border: '1px solid rgba(233, 30, 140, 0.2)', borderRadius: 12, color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 500, textAlign: 'left', fontFamily: 'inherit',
                          }}
                        >
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#e91e8c" strokeWidth="2"/><path d="M12 8V12M12 16H12.01" stroke="#e91e8c" strokeWidth="2" strokeLinecap="round"/></svg>
                          {t("login.instructions.whyWallet")}
                        </button>
                        <a
                          href={docServer}
                          target="_blank"
                          rel="noopener"
                          onClick={(e) => { setShowHelpPopup(false); smartOpenInNewTab(e, docServer); }}
                          style={{
                            display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', background: 'rgba(233, 30, 140, 0.08)',
                            border: '1px solid rgba(233, 30, 140, 0.2)', borderRadius: 12, color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 500, textDecoration: 'none', fontFamily: 'inherit',
                          }}
                        >
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M18 13V19C18 20.1046 17.1046 21 16 21H5C3.89543 21 3 20.1046 3 19V8C3 6.89543 3.89543 6 5 6H11" stroke="#e91e8c" strokeWidth="2" strokeLinecap="round"/><path d="M15 3H21V9" stroke="#e91e8c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M10 14L21 3" stroke="#e91e8c" strokeWidth="2" strokeLinecap="round"/></svg>
                          {t("login.instructions.docsPage")}
                        </a>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="terms-text">
                <span>
                  <a href="https://dwinity.com/terms/" target="_blank" rel="noreferrer">
                    {t('footer.links.terms')}{" "}
                  </a>{" "}
                  ·{" "}
                  <a href="https://dwinity.com/imprint/" target="_blank" rel="noreferrer">
                    {" "}
                    {t('footer.links.imprint')}{" "}
                  </a>{" "}
                  ·{" "}
                  <a href="https://dwinity.com/privacypolicy/" target="_blank" rel="noreferrer">
                    {" "}
                    {t('footer.links.privacyPolicy')}
                  </a>
                </span>
              </div>
            </div>
            <div className="d-flex d-lg-none footer-respo">
              <div className="help-button-respo" style={{ position: 'relative' }}>
                <button className="button outline medium" onClick={() => setShowHelpPopup(!showHelpPopup)}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" stroke="#ffffff" strokeWidth="2"/>
                    <path d="M9.5 9.5C9.5 8.11929 10.6193 7 12 7C13.3807 7 14.5 8.11929 14.5 9.5C14.5 10.4561 13.9407 11.2755 13.1291 11.6614C12.5077 11.9572 12 12.4477 12 13.1364V13.5" stroke="#ffffff" strokeWidth="2" strokeLinecap="round"/>
                    <circle cx="12" cy="17" r="1" fill="#ffffff"/>
                  </svg>
                  <span className="text">{t('header.menu.help')}</span>
                </button>
                {showHelpPopup && (
                  <>
                    <div style={{ position: 'fixed', inset: 0, zIndex: 9998 }} onClick={() => setShowHelpPopup(false)} onTouchEnd={(e) => { e.preventDefault(); setShowHelpPopup(false); }} />
                    <div style={{
                      position: 'fixed', bottom: 60, left: 12, right: 12, zIndex: 9999,
                      background: '#14142a', border: '1px solid rgba(233, 30, 140, 0.3)', borderRadius: 16,
                      padding: 20, boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                        <span style={{ fontSize: 18, fontWeight: 600, color: '#fff' }}>{t('header.menu.help')}</span>
                        <button onClick={() => setShowHelpPopup(false)} onTouchEnd={(e) => { e.preventDefault(); setShowHelpPopup(false); }} style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', padding: 4, fontSize: 18, lineHeight: 1 }}>✕</button>
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <button
                          onClick={() => { setShowHelpPopup(false); context.openModal("infomodalleft", ""); }}
                          onTouchEnd={(e) => { e.preventDefault(); setShowHelpPopup(false); context.openModal("infomodalleft", ""); }}
                          style={{
                            display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', background: 'rgba(233, 30, 140, 0.08)',
                            border: '1px solid rgba(233, 30, 140, 0.2)', borderRadius: 12, color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 500, textAlign: 'left', fontFamily: 'inherit',
                          }}
                        >
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#e91e8c" strokeWidth="2"/><path d="M12 8V12M12 16H12.01" stroke="#e91e8c" strokeWidth="2" strokeLinecap="round"/></svg>
                          {t("login.instructions.web3Ecosystem")}
                        </button>
                        <button
                          onClick={() => { setShowHelpPopup(false); context.openModal("infomodalright", ""); }}
                          onTouchEnd={(e) => { e.preventDefault(); setShowHelpPopup(false); context.openModal("infomodalright", ""); }}
                          style={{
                            display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', background: 'rgba(233, 30, 140, 0.08)',
                            border: '1px solid rgba(233, 30, 140, 0.2)', borderRadius: 12, color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 500, textAlign: 'left', fontFamily: 'inherit',
                          }}
                        >
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#e91e8c" strokeWidth="2"/><path d="M12 8V12M12 16H12.01" stroke="#e91e8c" strokeWidth="2" strokeLinecap="round"/></svg>
                          {t("login.instructions.whyWallet")}
                        </button>
                        <a
                          href={docServer}
                          target="_blank"
                          rel="noopener"
                          onClick={(e) => { setShowHelpPopup(false); smartOpenInNewTab(e, docServer); }}
                          style={{
                            display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', background: 'rgba(233, 30, 140, 0.08)',
                            border: '1px solid rgba(233, 30, 140, 0.2)', borderRadius: 12, color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 500, textDecoration: 'none', fontFamily: 'inherit',
                          }}
                        >
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M18 13V19C18 20.1046 17.1046 21 16 21H5C3.89543 21 3 20.1046 3 19V8C3 6.89543 3.89543 6 5 6H11" stroke="#e91e8c" strokeWidth="2" strokeLinecap="round"/><path d="M15 3H21V9" stroke="#e91e8c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M10 14L21 3" stroke="#e91e8c" strokeWidth="2" strokeLinecap="round"/></svg>
                          {t("login.instructions.docsPage")}
                        </a>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="terms-text-respo">
                <span>
                  <a
                    href="https://dwinity.com/terms/"
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => smartOpenInNewTab(e, "https://dwinity.com/terms/")}
                  >
                    {t('footer.links.terms')}{" "}
                  </a>{" "}
                  ·{" "}
                  <a
                    href="https://dwinity.com/imprint/"
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => smartOpenInNewTab(e, "https://dwinity.com/imprint/")}
                  >
                    {" "}
                    {t('footer.links.imprint')}{" "}
                  </a>{" "}
                  ·{" "}
                  <a
                    href="https://dwinity.com/privacypolicy/"
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => smartOpenInNewTab(e, "https://dwinity.com/privacypolicy/")}
                  >
                    {" "}
                    {t('footer.links.privacyPolicy')}
                  </a>
                </span>
              </div>
            </div>
          </>
        )}
        <div className="ticket-div"></div>
        {/*window.location.pathname !== "/files" && <>{window.innerWidth > 992 && <Footer />}</>*/}
      </div>
      {context.getState()?.modalName === "messagemodal" && (
        <MessageModal
          visible={context.getState()?.modalOpened}
          hideModal={context.closeModal}
          openLoginModal={context.openModal}
        />
      )}
      {context.getState()?.modalName === "infomodalleft" && (
        <InfoModalLeft
          visible={context.getState()?.modalOpened}
          hideModal={context.closeModal}
          openLoginModal={context.openModal}
        />
      )}
      {context.getState()?.modalName === "infomodalright" && (
        <InfoModalRight
          visible={context.getState()?.modalOpened}
          hideModal={context.closeModal}
          openLoginModal={context.openModal}
        />
      )}
      {context.getState()?.modalName === "centralinfo" && (
        <InfoModalCentral
          visible={context.getState()?.modalOpened}
          hideModal={context.closeModal}
          openLoginModal={context.openModal}
        />
      )}

      {context.getState()?.modalName === "fileupload" && (
        <FileUploadsModal
          visible={context.getState()?.modalOpened}
          modalParam={context.getState()?.modalParam}
          hideModal={context.closeModal}
          openLoginModal={context.openModal}
          modalText={context.getState()?.modalText}
        />
      )}

      {context.getState()?.modalName === "importorupload" && (
        <ImportOrUploadModal
          visible={context.getState()?.modalOpened}
          modalParam={context.getState()?.modalParam}
          hideModal={context.closeModal}
          openLoginModal={context.openModal}
          modalText={context.getState()?.modalText}
        />
      )}

      {context.getState()?.modalName === "dataimport" && (
        <DataimportModal
          visible={context.getState()?.modalOpened}
          modalParam={context.getState()?.modalParam}
          hideModal={context.closeModal}
          openLoginModal={context.openModal}
          modalText={context.getState()?.modalText}
        />
      )}

      {context.getState()?.modalName === "metafile" && (
        <MetafileModal
          visible={context.getState()?.modalOpened}
          modalParam={context.getState()?.modalParam}
          hideModal={context.closeModal}
          openLoginModal={context.openModal}
          modalText={context.getState()?.modalText}
        />
      )}

      {context.getState()?.modalName === "metadownloadhelp" && (
        <MetaDownloadHelpModal
          visible={context.getState()?.modalOpened}
          hideModal={context.closeModal}
          openLoginModal={context.openModal}
          modalText={context.getState()?.modalText}
        />
      )}
      {context.getState()?.modalName === "newfolder" && (
        <NewFolderModal
          visible={context.getState()?.modalOpened}
          modalParam={context.getState()?.modalParam}
          hideModal={context.closeModal}
          openLoginModal={context.openModal}
          modalText={context.getState()?.modalText}
        />
      )}
      {context.getState()?.modalName === "categoriesmodal" && (
        <CategoriesModal
          visible={context.getState()?.modalOpened}
          modalParam={context.getState()?.modalParam}
          hideModal={context.closeModal}
          openLoginModal={context.openModal}
          modalText={context.getState()?.modalText}
        />
      )}
      {context.getState()?.modalName === "categoriesmodaltest" && (
        <CategoriesModalTest
          visible={context.getState()?.modalOpened}
          modalParam={context.getState()?.modalParam}
          hideModal={context.closeModal}
          openLoginModal={context.openModal}
          modalText={context.getState()?.modalText}
        />
      )}
      {context.getState()?.modalName === "timelinemodal" && (
        <TimeLineModal
          visible={context.getState()?.modalOpened}
          hideModal={context.closeModal}
          openLoginModal={context.openModal}
          modalParam={context.getState()?.modalParam}
          modalText={context.getState()?.modalText}
        />
      )}
      {context.getState()?.modalName === "filedownloaderror" && (
        <InfoModalDownloadError
          visible={context.getState()?.modalOpened}
          hideModal={context.closeModal}
          openLoginModal={context.openModal}
          modalParam={context.getState()?.modalParam}
          modalText={context.getState()?.modalText}
        />
      )}
      {context.getState()?.modalName === "graphinfo" && (
        <InfoGraphModal
          visible={context.getState()?.modalOpened}
          hideModal={context.closeModal}
          openLoginModal={context.openModal}
          modalParam={context.getState()?.modalParam}
          modalText={context.getState()?.modalText}
        />
      )}

      {context.getState()?.modalName === "testmodal" && (
        <FilePreviewModal
          visible={context.getState()?.modalOpened}
          hideModal={context.closeModal}
          openLoginModal={context.openModal}
          modalParam={context.getState()?.modalParam}
          modalText={context.getState()?.modalText}
        />
      )}
      {context.getState()?.modalName === "imageupload" && (
        <Modal
          visible={context.getState()?.modalOpened}
          hideModal={context.closeModal}
          openLoginModal={context.openModal}
          modalParam={context.getState()?.modalParam}
          modalText={context.getState()?.modalText}
        />
      )}
      {context.showResumeModal && isConnected && selectedAccount && 
        window.location.pathname !== "/login" && window.location.pathname !== "/" && (
        <ResumeUploadModal
          visible={context.showResumeModal}
          onContinue={context.handleResumeContinue}
          onCancel={context.handleResumeCancel}
          onIgnore={context.handleResumeIgnore}
          batchStatus={context.resumeBatchStatus}
        />
      )}
    </>
  );
}

export default Layout;
